<template>
  <div
    :class="$style.container"
  >
    <div
      ref="content"
      :class="$style.content"
      data-test-id="content"
      @mouseleave="$emit('mouseLeaveHoverBox')"
      @mouseover="$emit('mouseOverHoverBox')"
    >
      <slot />
    </div>
    <div v-if="showCaret">
      <span
        ref="caret"
        :class="$style.caret"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HoverTooltip',

  props: {
    showCaret: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    const contentDiv = this.$refs.content;
    if ((contentDiv.offsetLeft + contentDiv.clientWidth) > window.innerWidth) {
      // it's going to overflow
      contentDiv.style.left = `${(window.innerWidth - contentDiv.clientWidth)}px`;
    }
    contentDiv.style.top = `${contentDiv.clientTop - contentDiv.clientHeight - 6}px`;
    if (this.showCaret) {
      const caretSpan = this.$refs.caret;
      caretSpan.style.top = `${contentDiv.clientTop - contentDiv.clientHeight - 10}px`;
    }
  },
};
</script>

<style module>
@value (tooltipOverlayZIndex, tooltipZIndex) from '~css/z-index.css';
@value (jcGrey700) from '~css/brand-colors.css';
@value (lightShadow3) from '~css/shadows.css';

.caret {
  border: 5px solid transparent;
  border-top-color: jcGrey700;
  box-shadow: lightShadow3;
  display: inline-block;
  opacity: 90%;
  position: relative;
}

.content {
  background-color: jcGrey700;
  border-radius: 4px;
  box-shadow: lightShadow3;
  color: white;
  display: flex;
  flex-direction: column;
  font-weight: 800;
  justify-content: space-around;
  min-height: 70px;
  opacity: 90%;
  padding: 10px 15px;
  pointer-events: auto;
  position: relative;
  transform: translateX(-20px);
  white-space: nowrap;
}

.container {
  pointer-events: none;
  z-index: tooltipZIndex;
}
</style>
